import { axiosInstance as request } from '@api/rest.service'
import { getFilters } from '@/modular-api/utils'

const api = '/exports'

const baseRequestOptions = {
  responseType: 'arraybuffer',
  headers: {
    'Content-Type': 'application/json'
  }
}

/**
 * @description GET /exports/{entity} (+ag grid filter model)
 * @returns {AxiosPromise<any>}
 */
export const GET_EXPORT_ENTITY_LINK = (entity, filters = [], agGridFilterModel = {}) => {
  const params = {
    ...getFilters(filters),
    ...agGridFilterModel
  }

  return request.get(`${api}/${entity}`, {
    ...baseRequestOptions,
    params
  })
}

/**
 * @description GET /exports/department-spend-overview/{departmentId}
 * @param {number|null} id
 * @returns {AxiosPromise<any>}
 */
export const DEPARTMENT_SPEND_OVERVIEW = id =>
  request.get(`${api}/department-spend-overview/${id}`, {
    ...baseRequestOptions
  })
